import SidebarTemplate from './sidebar.html';

function Sidebar(Auth, SidebarService, $filter) {
	'ngInject';

	const directive = {
		restrict: 'E',
		template: SidebarTemplate,
		link: link,
		scope: {}
	};

	return directive;

	function link(scope) {
		SidebarService.getCurrentUserRoles()
			.then(function(currentUserRoles) {
				scope.menuItems = [
					{
						'label': $filter('translate')('SIDEBAR.TICKETS'),
						'icon': 'fa-ticket',
						'state': 'app.private.tickets.chooseSubLine',
						'rootState': 'app.private.tickets.*',
						'visible': scope.hasPermission(['owner', 'administrator', 'office', 'agent'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.SALES'),
						'icon': 'fa-tags',
						'state': 'app.private.sales.list',
						'rootState': 'app.private.sales.*',
						'visible': scope.hasPermission(['owner', 'administrator', 'office', 'agent'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.REPORTS'),
						'icon': 'fa-line-chart',
						'state': 'app.private.reports.list',
						'rootState': 'app.private.reports.*',
						'visible': scope.hasPermission(['owner', 'administrator', 'office', 'agent'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.WAYBILL'),
						'icon': 'fa-list-alt',
						'state': 'app.private.waybill.chooseBus',
						'rootState': 'app.private.waybill.*',
						'visible': scope.hasPermission(['owner', 'administrator', 'office'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.CITIES'),
						'icon': 'fa-building',
						'state': 'app.private.cities.list',
						'rootState': 'app.private.cities.*',
						'visible': scope.hasPermission([], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.STATIONS'),
						'icon': 'fa-map',
						'state': 'app.private.stations.list',
						'rootState': 'app.private.stations.*',
						'visible': scope.hasPermission([], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.LINES'),
						'icon': 'fa-exchange',
						'state': 'app.private.lines.list',
						'rootState': 'app.private.lines.*',
						'visible': scope.hasPermission(['owner'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.BUSES'),
						'icon': 'fa-bus',
						'state': 'app.private.buses.chooseLine',
						'rootState': 'app.private.buses.*',
						'visible': scope.hasPermission(['owner'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.LOCK_SEATS'),
						'icon': 'fa-lock',
						'state': 'app.private.seats.chooseLine',
						'rootState': 'app.private.seats.*',
						'visible': scope.hasPermission(['owner'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.NEGOTIATED'),
						'icon': 'fa-briefcase',
						'state': 'app.private.negotiated-seats',
						'rootState': 'app.private.negotiated-seats',
						'visible': scope.hasPermission(['owner', 'administrator'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.PRICES'),
						'icon': 'fa-money ',
						'state': 'app.private.prices.chooseLine',
						'rootState': 'app.private.prices.*',
						'visible': scope.hasPermission(['owner'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.DISCOUNTS'),
						'icon': 'fa-percent ',
						'state': 'app.private.discounts.list',
						'rootState': 'app.private.discounts.*',
						'visible': scope.hasPermission(['owner'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.PROMOTIONS'),
						'icon': 'fa-bullhorn',
						'state': 'app.private.promotions.list',
						'rootState': 'app.private.promotions.*',
						'visible': scope.hasPermission(['owner'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.CURRENCIES'),
						'icon': 'fa-eur',
						'state': 'app.private.currencies.list',
						'rootState': 'app.private.currencies.*',
						'visible': scope.hasPermission(['owner', 'administrator'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.OFFICES'),
						'icon': 'fa-users',
						'state': 'app.private.offices.list',
						'rootState': 'app.private.offices.*',
						'visible': scope.hasPermission(['owner', 'administrator'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.AGENTS'),
						'icon': 'fa-user',
						'state': 'app.private.agents.list',
						'rootState': 'app.private.agents.*',
						'visible': scope.hasPermission(['owner', 'administrator'], currentUserRoles)
					},
					{
						'label': $filter('translate')('SIDEBAR.ADMINISTRATORS'),
						'icon': 'fa-male',
						'state': 'app.private.administrators.list',
						'rootState': 'app.private.administrators.*',
						'visible': scope.hasPermission(['owner'], currentUserRoles)
					},
					{
						'label': $filter('translate')('HEADING.CHANGE_PASSWORD'),
						'icon': 'fa-key',
						'state': 'app.private.changePassword',
						'rootState': 'app.private.changePassword.*',
						'visible': scope.hasPermission(['owner', 'administrator', 'agent', 'office'], currentUserRoles)
					}
				];
			});

		scope.logout = Auth.logout;

		scope.hasPermission = function(rolesWithPermission, currentUserRoles) {
			if (currentUserRoles.length) {
				for (let i = 0; i < currentUserRoles.length; i++) {
					if (rolesWithPermission.indexOf(currentUserRoles[i].name) !== -1) {
						return true;
					}
				}
			}

			return false;
		};
	}
}

export default Sidebar;




/** WEBPACK FOOTER **
 ** ./client/components/sidebar/sidebar.directive.js
 **/